import * as React from "react";

// eslint-disable-next-line no-restricted-imports
import { renderAppSplitButton } from "@1js/acui-button/lib/Next";
import { shallowCompareWithMenuDefinitionCheck } from "@1js/acui-common";

import type { RibbonSplitButtonInternalProps } from "../RibbonSplitButton";
import type { RibbonSplitButtonProps } from "./RibbonSplitButton.types";
import { useRibbonSplitButton } from "./useRibbonSplitButton";
import { useRibbonSplitButtonStyles } from "./useRibbonSplitButtonStyles.styles";

export const RibbonSplitButton = React.memo(
  React.forwardRef<HTMLButtonElement, RibbonSplitButtonInternalProps>(
    (props, ref) => {
      const state = useRibbonSplitButton(
        {
          ...props,
          size: props.size?.toLowerCase() as RibbonSplitButtonProps["size"],
        },
        ref
      );

      useRibbonSplitButtonStyles(state);

      return renderAppSplitButton(state, props as RibbonSplitButtonProps);
    }
  ),
  shallowCompareWithMenuDefinitionCheck
);

RibbonSplitButton.displayName = "next/RibbonSplitButton";
